/** Public site origin for emailed links (prod). Fallback: window.origin in browser. */
export function getPublicSiteOrigin(): string {
  const configured = process.env.REACT_APP_PUBLIC_SITE_URL?.replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
